var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h5', {
    staticClass: "mb-1"
  }), _c('a-form', {
    attrs: {
      "layout": "inline"
    }
  }, [_c('a-form-item', {
    attrs: {
      "help": _vm._trs('Delivery date')
    }
  }, [_c('a-range-picker', {
    attrs: {
      "placeholder": [_vm._trs('Start date'), _vm._trs('End date')],
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1), _c('a-form-item', [_c('a-button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v(_vm._s(_vm._trs('Get results')))])], 1), _c('div', {
    staticClass: "pull-right"
  }, [_c('a-button', {
    staticClass: "button-period",
    attrs: {
      "type": "dashed",
      "size": _vm.buttonSize
    },
    on: {
      "click": function click($event) {
        return _vm.setPeriod($event, 'day');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm._trs('Day')) + " ")]), _c('a-button', {
    staticClass: "button-period",
    attrs: {
      "type": "dashed",
      "size": _vm.buttonSize
    },
    on: {
      "click": function click($event) {
        return _vm.setPeriod($event, 'week');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm._trs('Week')) + " ")]), _c('a-button', {
    staticClass: "button-period",
    attrs: {
      "type": "dashed",
      "size": _vm.buttonSize
    },
    on: {
      "click": function click($event) {
        return _vm.setPeriod($event, 'month');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm._trs('Month')) + " ")]), _c('a-button', {
    staticClass: "button-period",
    attrs: {
      "type": "dashed",
      "size": _vm.buttonSize
    },
    on: {
      "click": function click($event) {
        return _vm.setPeriod($event, 'quartal');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm._trs('Quarter')) + " ")]), _c('a-button', {
    staticClass: "button-period",
    attrs: {
      "type": "dashed",
      "size": _vm.buttonSize
    },
    on: {
      "click": function click($event) {
        return _vm.setPeriod($event, 'year');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm._trs('Year')) + " ")])], 1)], 1), _c('div', [_c('h5', {
    staticClass: "font-weight-light mb-3 mt-5"
  }, [_vm._v(_vm._s(_vm._trs('Price')))]), _c('a-checkbox-group', {
    attrs: {
      "options": _vm.plainOptions
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: _vm.checkedList,
      callback: function callback($$v) {
        _vm.checkedList = $$v;
      },
      expression: "checkedList"
    }
  }), _c('div', {
    staticClass: "mb-10",
    staticStyle: {
      "height": "320px"
    },
    attrs: {
      "id": "day-ahead-result-price-chart"
    }
  }), _c('h5', {
    staticClass: "font-weight-light mb-3 mt-5"
  }, [_vm._v(_vm._s(_vm._trs('Volume')))]), _c('div', {
    staticClass: "mb-10",
    staticStyle: {
      "height": "320px"
    },
    attrs: {
      "id": "day-ahead-result-qty-chart"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }